import { InjectionToken } from '@angular/core';
import { Params } from '@angular/router';

import { AutoTopUpActions, OverboekenBackendActions, OverboekenFrontendActions } from './routes';

export const WEBCOMPONENT_IDENTIFIER_TOKEN = new InjectionToken<string>('webcomponentIdentifier');

export const MijnWebcomponentProviderName = 'webcomponentIdentifier';
export const MijnNavigationSessionName = 'mijn-navigatie';
export const MijnNavigatieHistoryName = 'history';

export enum MijnWebcomponentIdentifier {
    MIJN_AFLOSVRIJ_CHECK = 'mijn-aflosvrij-check-wrapper',
    MIJN_AI_CONSENT = 'mijn-ai-consent-wrapper',
    MIJN_AUTO_TOP_UP = 'mijn-auto-top-up-wrapper',
    MIJN_BELEGGEN_PORTFOLIO = 'mijn-beleggen-portfolio-wrapper',
    MIJN_BERICHTEN_OVERZICHT = 'mijn-berichten-overzicht-wrapper',
    MIJN_BETALEN_BETAALREKENING_AANVULLEN = 'mijn-betalen-betaalrekening-aanvullen-wrapper',
    MIJN_BETALEN_BETAALBATCHES = 'mijn-betalen-betaalbatches-wrapper',
    MIJN_BETALEN_BETAALVERZOEK = 'mijn-betalen-betaalverzoek-wrapper',
    MIJN_BUDGET = 'mijn-budget-wrapper',
    MIJN_CONTACT = 'mijn-contact-wrapper',
    MIJN_CONTACT_TELEFONIE = 'mijn-contact-telefonie-wrapper',
    MIJN_DIGIPAS_DEBLOKKEREN = 'mijn-digipas-deblokkeren-wrapper',
    MIJN_DIGITAAL_ADRES_WIJZIGEN = 'mijn-digitaal-adres-wijzigen-wrapper',
    MIJN_DOCUMENTEN_OVERZICHT = 'mijn-documenten-overzicht-wrapper',
    MIJN_ECOMMERCE_PAYMENTS = 'mijn-ecommerce-payments-wrapper',
    MIJN_EXTERNE_BETALING = 'mijn-externe-betaling-wrapper',
    MIJN_HUISMAP = 'mijn-huismap-wrapper',
    MIJN_HYPOTHEKEN_AFLOSSEN = 'mijn-hypotheken-aflossen-wrapper',
    MIJN_HYPOTHEKEN_AFLOSSINGSVRIJ = 'mijn-hypotheken-aflossingsvrij-wrapper',
    MIJN_HYPOTHEKEN_AFLOSSINGSVRIJ_OMZETTEN = 'mijn-hypotheken-aflossingsvrij-omzetten-wrapper',
    MIJN_HYPOTHEKEN_BOUWDEPOT = 'mijn-hypotheken-bouwdepot-wrapper',
    MIJN_HYPOTHEKEN_DOCUMENTUPLOAD = 'mijn-hypotheken-documentupload-wrapper',
    MIJN_HYPOTHEKEN_DOCUMENTEN_UPLOADEN = 'mijn-hypotheken-documenten-uploaden-wrapper',
    MIJN_HYPOTHEKEN_EXTRA_STORTEN = 'mijn-hypotheken-extra-storten-wrapper',
    MIJN_HYPOTHEKEN_HOME = 'mijn-hypotheken-home-wrapper',
    MIJN_HYPOTHEKEN_INCASSOREKENING = 'mijn-hypotheken-incassorekening-wrapper',
    MIJN_HYPOTHEKEN_RENTEVERLENGING = 'mijn-hypotheken-renteverlenging-wrapper',
    MIJN_HYPOTHEKEN_VERHOGEN = 'mijn-hypotheken-verhogen-wrapper',
    MIJN_HYPOTHEKEN_WONINGWAARDE = 'mijn-hypotheken-woningwaarde-wrapper',
    MIJN_INCASSOBATCHES = 'mijn-incassobatches-wrapper',
    MIJN_GELD_INZICHT = 'mijn-geld-inzicht-wrapper',
    MIJN_GELD_INZICHT_CATEGORIE = 'mijn-geld-inzicht-categorie-wrapper',
    MIJN_IDEAL_ZELFSERVICE = 'mijn-ideal-zelfservice-wrapper',
    MIJN_IDIN_ZELFSERVICE = 'mijn-idin-zelfservice-wrapper',
    MIJN_KLANT_ADRESBOEK = 'mijn-klant-adresboek-wrapper',
    MIJN_KLANT_AFSPRAKENBEHEER = 'mijn-klant-afsprakenbeheer-wrapper',
    MIJN_KLANT_AUTOMATIONS = 'mijn-klant-automations-wrapper',
    MIJN_KLANT_BETAALPASSEN = 'mijn-klant-betaalpassen-wrapper',
    MIJN_KLANT_CONTACTGEGEVENS = 'mijn-klant-contactgegevens-wrapper',
    MIJN_KLANT_HERIDENTIFICATIE = 'mijn-klant-heridentificatie-wrapper',
    MIJN_KLANT_LOPENDE_ZAKEN = 'mijn-klant-lopende-zaken-wrapper',
    MIJN_KLANT_NOTIFICATIE_BEHEER = 'mijn-klant-notificatie-beheer-wrapper',
    MIJN_KLANT_ONBOARDING = 'mijn-klant-onboarding-wrapper',
    MIJN_KLANT_SECURITY_AWARENESS = 'mijn-klant-security-awareness-wrapper',
    MIJN_KLANT_TOEGANG_DERDEN_BEHEER = 'mijn-klant-toegang-derden-beheer-wrapper',
    MIJN_KLANT_TOESTEMMINGEN = 'mijn-klant-toestemmingen-wrapper',
    MIJN_KLANT_VOORKEURSREKENING = 'mijn-klant-voorkeursrekening-wrapper',
    MIJN_KLANT_ZELFSERVICE = 'mijn-klant-zelfservice-wrapper',
    MIJN_LENINGEN_AANVRAGEN = 'mijn-leningen-aanvragen-wrapper',
    MIJN_OVERBOEKEN = 'mijn-overboeken-wrapper',
    MIJN_OVERZICHT = 'mijn-overzicht-wrapper',
    MIJN_PENDING_PAYMENTS = 'mijn-pending-payments-wrapper',
    MY_PENSION_EXPANSION_REQUEST = 'my-pension-expansion-request-wrapper',
    MIJN_PERSOONLIJKE_LENING = 'mijn-persoonlijke-lening-wrapper',
    MIJN_PRODUCT_TOEVOEGEN = 'mijn-product-toevoegen-wrapper',
    MIJN_PRODUCT_AANVRAGEN = 'mijn-product-aanvragen-wrapper',
    MIJN_REKENING = 'mijn-rekening-wrapper',
    MIJN_REKENINGEN_OPGEHEVEN = 'mijn-rekeningen-opgeheven-wrapper',
    MIJN_SALDO_GRAFIEK = 'mijn-saldo-grafiek-wrapper',
    MIJN_SPAARPOT = 'mijn-spaarpot-wrapper',
    MIJN_TOEGANGSNAAM_WACHTWOORD_AANVRAGEN = 'mijn-toegangsnaam-wachtwoord-aanvragen-wrapper',
    MIJN_TOKENS_AUTHENTICATIE_HISTORIE = 'mijn-tokens-authenticatie-historie-wrapper',
    MIJN_TOKENS_BEHEER = 'mijn-tokens-beheer-wrapper',
    MIJN_TOKENS_DIGICODE = 'mijn-tokens-digicode-wrapper',
    MIJN_TOKENS_LIMIETEN = 'mijn-tokens-limieten-wrapper',
    MIJN_TRANSACTIES_DOWNLOADEN = 'mijn-transacties-downloaden-wrapper',
    MIJN_REKENINGSTANDEN_DOWNLOADEN = 'mijn-rekeningstanden-downloaden-wrapper',
    MIJN_TELEPHONY_CONSENT = 'mijn-telephony-consent-wrapper',
    MIJN_TRANSACTIES_GEWEIGERD = 'mijn-transacties-geweigerd-wrapper',
    MIJN_TRANSACTIES_INCASSO = 'mijn-transacties-incasso-wrapper',
    MIJN_TRANSACTIES_INGEPLAND = 'mijn-transacties-ingepland-wrapper',
    MIJN_VASTE_LASTEN = 'mijn-vaste-lasten-wrapper',
    MIJN_VERZEKEREN_AANVRAGEN = 'mijn-verzekeren-aanvragen-wrapper',
    MIJN_VERZEKEREN_BEHEER = 'mijn-verzekeren-beheer-wrapper',
    MIJN_VERZEKEREN_PROCESSEN = 'mijn-verzekeren-processen-wrapper',
    MIJN_WIJZIGEN_AFSCHRIFTFREQUENTIE = 'mijn-wijzigen-afschriftfrequentie',
    MIJN_ZAKELIJK_EXTRA_AFLOSSEN = 'mijn-zakelijk-extra-aflossen-wrapper',
    MIJN_ZAKELIJK_DIGIPAS_VERVANGEN = 'mijn-zakelijk-digipas-vervangen-wrapper'
}

export declare interface MijnNavigationEvents {
    toAccountsOverview(): Promise<boolean>;
    toAdresboek(): Promise<boolean>;
    toAflosvrijCheck(): Promise<boolean>;
    toAfsprakenbeheer(): Promise<boolean>;
    toAlerts(): Promise<boolean>;
    toAlertsSecurity(): Promise<boolean>;
    toAsnMigrationOnboarding(): Promise<boolean>;
    toAuthenticatieHistorie(): Promise<boolean>;
    toAutoTopUp(autoTopUpQueryParams?: AutoTopUpQueryParams): Promise<boolean>;
    toBalanceChart(balanceChartParams: BalanceChartParams): Promise<boolean>;
    toBeleggen(pathParam?: PathParam): Promise<boolean>;
    toBeleggenBeheer(pathParam: PathParam): Promise<boolean>;
    toBericht(pathParam: PathParam): Promise<boolean>;
    toBerichten(): Promise<boolean>;
    toBerichtvoorkeuren(): Promise<boolean>;
    toBerichtvoorkeurenNba(): Promise<boolean>;
    toBetaalbatches(): Promise<boolean>;
    toBetaalbatchesAfgerondBestand(): Promise<boolean>;
    toBetaalbatchesBatchbestanddetails(): Promise<boolean>;
    toBetaalbatchesBatchdetails(): Promise<boolean>;
    toBetaalbatchesSign(): Promise<boolean>;
    toBetaalbatchesResult(): Promise<boolean>;
    toBetaalbatchesUpload(): Promise<boolean>;
    toBetaalpassen(): Promise<boolean>;
    toEcommerce(pathParam?: PathParam): Promise<boolean>;
    toEcommerceSummary(): Promise<boolean>;
    toFixedExpenses(): Promise<boolean>;
    toBetaalverzoek(): Promise<boolean>;
    toBouwdepotAdresNieuweWoningDoorgeven(): Promise<boolean>;
    toBouwdepotBeeindigen(): Promise<boolean>;
    toBouwdepotDeclaratie(): Promise<boolean>;
    toBudgets(): Promise<boolean>;
    toBudgetCreate(budgetParams: BudgetCreateParams): Promise<boolean>;
    toBudgetDetails(budgetParams: BudgetParams): Promise<boolean>;
    toBudgetEdit(budgetParams: BudgetParams): Promise<boolean>;
    toContact(): Promise<boolean>;
    toContactTelefonie(): Promise<boolean>;
    toContactgegevensBeheren(queryParams?: ContactgegevensQueryParams): Promise<boolean>;
    toDigipasVerwijderen(pathParam: PathParam): Promise<boolean>;
    toDigipasDeblokkeren(): Promise<boolean>;
    toDigitaalAdresWijzigen(): Promise<boolean>;
    toDocumenten(): Promise<boolean>;
    toExterneBetaling(): Promise<boolean>;
    toFout(): Promise<boolean>;
    toGebruikersnaamWachtwoordWijzigen(pathParam: PathParam): Promise<boolean>;
    toHeridentificatie(): Promise<boolean>;
    toGeweigerd(optionalAccountDetails?: OptionalAccountDetails): Promise<boolean>;
    toHelaas(): Promise<boolean>;
    toHomepage(params?: HomepageParams): Promise<boolean>;
    toHuismap(): Promise<boolean>;
    toHypotheek(): Promise<boolean>;
    toHypotheekDetails(): Promise<boolean>;
    toHypotheekEnergylabel(): Promise<boolean>;
    toHypothekenAflossingsvrij(): Promise<boolean>;
    toHypothekenAflossingsvrijOmzetten(): Promise<boolean>;
    toHypothekenDocumentupload(pathParam: HypothekenDocumentupload): Promise<boolean>;
    toHypothekenDocumentenUploaden(): Promise<boolean>;
    toHypothekenExtraStorten(): Promise<boolean>;
    toHypothekenIncassorekening(): Promise<boolean>;
    toHypothekenAflossen(): Promise<boolean>;
    toHypothekenVerhogen(): Promise<boolean>;
    toHypothekenVerhogenKennistoets(): Promise<boolean>;
    toHypothekenVerhogenAanvraag(): Promise<boolean>;
    toHypothekenWoningwaarde(): Promise<boolean>;
    toIdealZelfservice(): Promise<boolean>;
    toIdealZelfserviceDetails(): Promise<boolean>;
    toIdealZelfserviceError(): Promise<boolean>;
    toIdealZelfserviceProfielAanmaken(): Promise<boolean>;
    toIdin(): Promise<boolean>;
    toIncasso(selectedAccountDetails?: SelectedAccountDetails): Promise<boolean>;
    toIncassoAddPermission(): Promise<boolean>;
    toIncassoChangePermissionList(): Promise<boolean>;
    toIncassoRefund(): Promise<boolean>;
    toIncassoRefuse(): Promise<boolean>;
    toIncassoRemovePermission(): Promise<boolean>;
    toIncassoUpdatePermission(): Promise<boolean>;
    toIncassobatches(): Promise<boolean>;
    toIncassobatchesDetails(): Promise<boolean>;
    toIncassobatchesError(): Promise<boolean>;
    toIncassobatchesSign(): Promise<boolean>;
    toIncassobatchesSuccess(): Promise<boolean>;
    toIncassobatchesUpload(): Promise<boolean>;
    toIncassobatchesUitvalrapportages(incassobatchesUitvalrapportagesDetails?: IncassobatchesUitvalrapportagesDetails): Promise<boolean>;
    toIncassoNotificatie(): Promise<boolean>;
    toIngeplandeOverboeking(optionalAccountDetails?: OptionalAccountDetails): Promise<boolean>;
    toIngeplandGeweigerdNotificatie(pathParam: PathParam): Promise<boolean>;
    toIngeplandGeweigerdNotificaties(): Promise<boolean>;
    toInkomstenUitgaven(inkomstenUitgavenDetails?: InkomstenUitgavenDetails): Promise<boolean>;
    toInkomstenUitgavenCategorie(inkomstenUitgavenCategorieDetails?: InkomstenUitgavenCategorieDetails): Promise<boolean>;
    toLenen(): Promise<boolean>;
    toLenenBeheer(): Promise<boolean>;
    toLimieten(): Promise<boolean>;
    toManageAccess(): Promise<boolean>;
    toOpenstaandeActies(): Promise<boolean>;
    toNewBetaalverzoek(betaalverzoekDetails?: BetaalverzoekDetails): Promise<boolean>;
    toNotificatiesBeheren(notificatiesBeherenParams?: NotificatiesBeherenParams): Promise<boolean>;
    toOnlineBankierenKind(): Promise<boolean>;
    toOpgehevenRekeningen(): Promise<boolean>;
    toOrder(pathParam: PathParam): Promise<boolean>;
    toOrderHistory(pathParam: PathParam): Promise<boolean>;
    toFinancialReturn(pathParam: PathParam): Promise<boolean>;
    toPortfolio(pathParam: PathParam): Promise<boolean>;
    toCash(pathParam: PathParam): Promise<boolean>;
    toOrders(pathParam: PathParam): Promise<boolean>;
    toOrderAllocation(pathParam: PathParam): Promise<boolean>;
    toSustainableReturn(pathParam: PathParam): Promise<boolean>;
    toPlanner(pathParam: PathParam): Promise<boolean>;
    toPlannerOverview(pathParam: PathParam): Promise<boolean>;
    toOrderOverzicht(pathParam: PathParam): Promise<boolean>;
    toBeleggenSigneren(pathParam: PathParam): Promise<boolean>;
    toBeleggenComplete(pathParam: PathParam): Promise<boolean>;
    toBeleggenCancelAccount(pathParam: PathParam): Promise<boolean>;
    toOverboeken(details?: OverboekenQueryParams): Promise<boolean>;
    toOverboekenSpaarpot(): Promise<boolean>;
    toOverboekenOndertekenen(): Promise<boolean>;
    toOverboekenOverzicht(): Promise<boolean>;
    toOverviewEdit(): Promise<boolean>;
    toPaginaNietGevonden(): Promise<boolean>;
    toPendingPayments(): Promise<boolean>;
    toPensionExpansionRequestInvestment(): Promise<boolean>;
    toPensionExpansionRequestDeposit(): Promise<boolean>;
    toPersoonlijkeLening(pathParam?: PathParam): Promise<boolean>;
    toPrivacy(): Promise<boolean>;
    toProductAanvragen(productAanvraag?: ProductAanvraag): Promise<boolean>;
    toProductToevoegen(): Promise<boolean>;
    toProductCatalog(): Promise<boolean>;
    toAiConsent(aiConsentParams?: AiConsentParams): Promise<boolean>;
    toRekening(rekeningDetails?: RekeningDetails): Promise<boolean>;
    toRenteRegulierVerlengen(): Promise<boolean>;
    toRenteTussentijdsAanpassen(): Promise<boolean>;
    toSaldoNotificatie(pathParam: PathParam): Promise<boolean>;
    toSaldoNotificaties(): Promise<boolean>;
    toSecurityAwareness(): Promise<boolean>;
    toSpaarpot(pathParam: PathParam): Promise<boolean>;
    toTelephonyConsent(): Promise<boolean>;
    toToegangDerdenBeheren(): Promise<boolean>;
    toToegangGegevensDelen(): Promise<boolean>;
    toToegangsnaamWachtwoordAanvragen(toegangsnaamWachtwoordAanvraag: ToegangsnaamWachtwoordAanvraag): Promise<boolean>;
    toTokenBeheer(): Promise<boolean>;
    toTransactieNotificatie(pathParam: PathParam): Promise<boolean>;
    toTransactieNotificaties(): Promise<boolean>;
    toTransactiesDownloaden(transactiesDownloadenDetails?: TransactiesDownloadenDetails): Promise<boolean>;
    toRekeningstandenDownloaden(): Promise<boolean>;
    toVeiligheidEnToegang(): Promise<boolean>;
    toVerzekerenBeheren(): Promise<boolean>;
    toVerzekerenDetails(pathParam: PathParam): Promise<boolean>;
    toVerzekerenProductAddition(pathParam: PathParam): Promise<boolean>;
    toVerzekerenProductPage(pathParam: PathParam): Promise<boolean>;
    toVerzekerenMaintenance(): Promise<boolean>;
    toVerzendlijst(): Promise<boolean>;
    toVolgendeHypotheekAfschrijving(): Promise<boolean>;
    toVoorkeursrekeningBeheren(): Promise<boolean>;
    toVorigeHypotheekAfschrijvingen(): Promise<boolean>;
    toWijzigenAfschriftfrequentie(): Promise<boolean>;
    toZakelijkGeblokkeerd(): Promise<boolean>;
    toZelfRegelen(): Promise<boolean>;
    toZelfRegelenHypotheken(): Promise<boolean>;
    toZelfRegelenRekeningen(): Promise<boolean>;
    toZakelijkExtraAflossen(): Promise<boolean>;
    toZakelijkDigipasVervangen(pathParam: PathParam): Promise<boolean>;
}

export const MijnNavigationEventsList = [
    'toAccountsOverview',
    'toAdresboek',
    'toAflosvrijCheck',
    'toAfsprakenbeheer',
    'toAlerts',
    'toAlertsSecurity',
    'toAsnMigrationOnboarding',
    'toAuthenticatieHistorie',
    'toAutoTopUp',
    'toBalanceChart',
    'toBeleggen',
    'toBeleggenBeheer',
    'toBericht',
    'toBerichten',
    'toBerichtvoorkeuren',
    'toBerichtvoorkeurenNba',
    'toBetaalbatches',
    'toBetaalbatchesAfgerondBestand',
    'toBetaalbatchesBatchbestanddetails',
    'toBetaalbatchesBatchdetails',
    'toBetaalbatchesSign',
    'toBetaalbatchesResult',
    'toBetaalbatchesUpload',
    'toBetaalpassen',
    'toEcommerce',
    'toEcommerceSummary',
    'toBetaalverzoek',
    'toBouwdepotAdresNieuweWoningDoorgeven',
    'toBouwdepotBeeindigen',
    'toBouwdepotDeclaratie',
    'toBudgets',
    'toBudgetCreate',
    'toBudgetEdit',
    'toBudgetDetails',
    'toContact',
    'toContactTelefonie',
    'toContactgegevensBeheren',
    'toDigipasDeblokkeren',
    'toDigipasVerwijderen',
    'toDigitaalAdresWijzigen',
    'toDocumenten',
    'toExterneBetaling',
    'toFixedExpenses',
    'toFout',
    'toGebruikersnaamWachtwoordWijzigen',
    'toHeridentificatie',
    'toGeweigerd',
    'toHelaas',
    'toHomepage',
    'toHuismap',
    'toHypotheek',
    'toHypotheekDetails',
    'toHypotheekEnergylabel',
    'toHypothekenAflossen',
    'toHypothekenAflossingsvrij',
    'toHypothekenAflossingsvrijOmzetten',
    'toHypothekenDocumentupload',
    'toHypothekenDocumentenUploaden',
    'toHypothekenExtraStorten',
    'toHypothekenIncassorekening',
    'toHypothekenVerhogen',
    'toHypothekenVerhogenAanvraag',
    'toHypothekenVerhogenKennistoets',
    'toHypothekenWoningwaarde',
    'toIdealZelfservice',
    'toIdealZelfserviceDetails',
    'toIdealZelfserviceError',
    'toIdealZelfserviceProfielAanmaken',
    'toIdin',
    'toIncasso',
    'toIncassoAddPermission',
    'toIncassoChangePermissionList',
    'toIncassoRefund',
    'toIncassoRefuse',
    'toIncassoRemovePermission',
    'toIncassoUpdatePermission',
    'toIncassobatches',
    'toIncassobatchesDetails',
    'toIncassobatchesError',
    'toIncassobatchesSign',
    'toIncassobatchesSuccess',
    'toIncassobatchesUpload',
    'toIncassobatchesUitvalrapportages',
    'toIncassoNotificatie',
    'toIngeplandeOverboeking',
    'toIngeplandGeweigerdNotificatie',
    'toIngeplandGeweigerdNotificaties',
    'toInkomstenUitgaven',
    'toInkomstenUitgavenCategorie',
    'toLenen',
    'toLenenBeheer',
    'toLimieten',
    'toManageAccess',
    'toNewBetaalverzoek',
    'toNotificatiesBeheren',
    'toOnlineBankierenKind',
    'toOpenstaandeActies',
    'toOpgehevenRekeningen',
    'toOrder',
    'toFinancialReturn',
    'toPortfolio',
    'toCash',
    'toOrders',
    'toOrderAllocation',
    'toSustainableReturn',
    'toPlanner',
    'toPlannerOverview',
    'toBeleggenSigneren',
    'toBeleggenComplete',
    'toBeleggenCancelAccount',
    'toOrderHistory',
    'toOrderOverzicht',
    'toOverboeken',
    'toOverboekenSpaarpot',
    'toOverboekenOndertekenen',
    'toOverboekenOverzicht',
    'toOverviewEdit',
    'toPaginaNietGevonden',
    'toPendingPayments',
    'toPensionExpansionRequestInvestment',
    'toPensionExpansionRequestDeposit',
    'toPersoonlijkeLening',
    'toPrivacy',
    'toProductCatalog',
    'toProductToevoegen',
    'toProductAanvragen',
    'toAiConsent',
    'toRekening',
    'toRekeningstandenDownloaden',
    'toRenteRegulierVerlengen',
    'toRenteTussentijdsAanpassen',
    'toSaldoNotificatie',
    'toSaldoNotificaties',
    'toSecurityAwareness',
    'toSpaarpot',
    'toTelephonyConsent',
    'toToegangDerdenBeheren',
    'toToegangGegevensDelen',
    'toToegangsnaamWachtwoordAanvragen',
    'toTokenBeheer',
    'toTransactieNotificatie',
    'toTransactieNotificaties',
    'toTransactiesDownloaden',
    'toVeiligheidEnToegang',
    'toVerzekerenBeheren',
    'toVerzekerenDetails',
    'toVerzekerenProductAddition',
    'toVerzekerenProductPage',
    'toVerzekerenMaintenance',
    'toVerzendlijst',
    'toVolgendeHypotheekAfschrijving',
    'toVoorkeursrekeningBeheren',
    'toVorigeHypotheekAfschrijvingen',
    'toWijzigenAfschriftfrequentie',
    'toZakelijkGeblokkeerd',
    'toZelfRegelen',
    'toZelfRegelenDynamicProcess',
    'toZelfRegelenHypotheken',
    'toZelfRegelenRekeningen',
    'toZakelijkExtraAflossen',
    'toZakelijkDigipasVervangen'
];

export interface HomepageParams extends Params {
    overzichtAanpassen?: boolean;
}

export interface InkomstenUitgavenDetails extends Params {
    rekening_id?: string;
    offset?: string;
}

export interface InkomstenUitgavenCategorieDetails extends InkomstenUitgavenDetails {
    categorie_id?: string;
    start_dag?: string;
    periode?: 'week' | 'maand';
    offset?: string;
    transactie_type?: 'credit' | 'debit' | 'own_accounts';
}

export interface PathParam extends Params {
    path: string;
}

export interface BalanceChartParams extends Params {
    rekening_id?: string;
}

export interface BudgetParams extends Params {
    rekeningId: string;
    budgetId: string;
}
export interface NotificatiesBeherenParams extends Params {
    rekeningId?: string;
}
export interface ContactgegevensQueryParams {
    action: string;
    phonenumber?: string;
}
export interface BudgetCreateParams extends Params {
    rekeningId: string;
    categoryId: string;
    periodType: string;
    startOn: string;
}

export interface OverboekenQueryParams extends Params {
    actie?: OverboekenBackendActions | OverboekenFrontendActions;
    id?: string;
    debtorId?: string;
    creditorId?: string;
    amount?: string;
    pov?: 'wk' | '4wk' | 'mo' | '3mos' | '6mos' | 'yr';
}

export interface TransactiesDownloadenDetails extends Params {
    account?: string;
    category?: string;
    creditDebit?: string;
    endAmount?: string;
    endDate?: string;
    format?: string;
    inactive?: boolean;
    notification?: TransactiesDownloadenNotification;
    query?: string;
    startAmount?: string;
    startDate?: string;
    transactionTypeFilter?: TransactionTypeFilter;
}

export enum TransactionTypeFilter {
    DIRECT_DEBIT = 'direct_debit',
    IDEAL = 'ideal',
    SWITCHINGSERVICE_TRANSACTION = 'switchingservice_transaction'
}

export enum TransactiesDownloadenNotification {
    PLANNED = 'planned'
}

export interface IncassobatchesUitvalrapportagesDetails extends PathParam {
    bestandsnaam?: string;
}

export interface RekeningDetails extends PathParam {
    tab?: 'bij-af' | 'kijk-vooruit' | 'spaarpotten' | 'zelf-regelen';
    melding?: 'spaarpot-verwijderd';
}

export interface AiConsentParams extends PathParam {
    tab?: 'zelf' | 'andere';
    klantnummer?: string;
}

export interface HypothekenDocumentupload extends PathParam {
    hypotheek_id?: string;
}

export interface BetaalverzoekDetails extends Params {
    rekening?: string;
    transactie_id?: string;
}

export interface SelectedAccountDetails extends Params {
    rekening: string;
}

export interface AutoTopUpQueryParams extends Params {
    actie: AutoTopUpActions;
    id: string;
}

export interface OptionalAccountDetails extends Params {
    path?: string;
    rekening?: string;
}

export interface PegaRequest extends Params {
    caseID?: string;
    assignmentID?: string;
    actionID?: string;
    initWithSubmit?: string;
}

export interface ProductAanvraag extends PegaRequest {
    /* eslint-disable @typescript-eslint/naming-convention */
    ProductID?: string;
    RequestSubType?: string;
    RequestType?: string;
    VerificationMethod?: string;
    /* eslint-enable @typescript-eslint/naming-convention */
}

export interface ToegangsnaamWachtwoordAanvraag extends PegaRequest {
    /* eslint-disable @typescript-eslint/naming-convention */
    RequestFor?: string;
    /* eslint-enable @typescript-eslint/naming-convention */
}

export enum MijnRouteKey {
    AUTO_TOP_UP = 'AUTO_TOP_UP',
    ACCOUNT = 'ACCOUNT',
    ACCOUNT_OVERVIEW = 'ACCOUNT_OVERVIEW',
    ADDRESS_BOOK = 'ADDRESS_BOOK',
    AI_CONSENT = 'AI_CONSENT',
    AFLOSVRIJ_CHECK = 'AFLOSVRIJ_CHECK',
    AFSPRAKENBEHEER = 'AFSPRAKENBEHEER',
    ASN_MIGRATION_ONBOARDING = 'ASN_MIGRATION_ONBOARDING',
    BALANCE_CHART = 'BALANCE_CHART',
    BUDGETS = 'BUDGETS',
    BUDGET_CREATE = 'BUDGET_CREATE',
    BUDGET_DETAILS = 'BUDGET_DETAILS',
    BUDGET_EDIT = 'BUDGET_EDIT',
    BUSINESS_CUSTOMER_BLOCKED = 'BUSINESS_CUSTOMER_BLOCKED',
    CHANGE_DIGITAL_ADDRESS = 'CHANGE_DIGITAL_ADDRESS',
    COLLECTION = 'COLLECTION',
    COLLECTION_ADD_PERMISSION = 'COLLECTION_ADD_PERMISSION',
    COLLECTION_CHANGE_PERMISSION_LIST = 'COLLECTION_CHANGE_PERMISSION_LIST',
    COLLECTION_REFUND = 'COLLECTION_REFUND',
    COLLECTION_REFUSE = 'COLLECTION_REFUSE',
    COLLECTION_REMOVE_PERMISSION = 'COLLECTION_REMOVE_PERMISSION',
    COLLECTION_UPDATE_PERMISSION = 'COLLECTION_UPDATE_PERMISSION',
    CONTACT = 'CONTACT',
    CONTACT_TELEFONIE = 'CONTACT_TELEFONIE',
    DOCUMENT_OVERVIEW = 'DOCUMENT_OVERVIEW',
    ERROR = 'ERROR',
    FIXED_EXPENSES = 'FIXED_EXPENSES',
    EXTERNE_BETALING = 'EXTERNE_BETALING',
    HUISMAP = 'HUISMAP',
    HYPOTHEKEN_DOCUMENTEN_UPLOADEN = 'HYPOTHEKEN_DOCUMENTEN_UPLOADEN',
    INCASSO_BATCHES = 'INCASSO_BATCHES',
    INCASSO_BATCHES_DETAILS = 'INCASSO_BATCHES_DETAILS',
    INCASSO_BATCHES_ERROR = 'INCASSO_BATCHES_ERROR',
    INCASSO_BATCHES_SIGN = 'INCASSO_BATCHES_SIGN',
    INCASSO_BATCHES_SUCCESS = 'INCASSO_BATCHES_SUCCESS',
    INCASSO_BATCHES_UPLOAD = 'INCASSO_BATCHES_UPLOAD',
    INCASSO_BATCHES_UITVALRAPPORTAGES = 'INCASSO_BATCHES_UITVALRAPPORTAGES',
    INCOME_AND_EXPENSE = 'INCOME_AND_EXPENSE',
    INCOME_AND_EXPENSE_CATEGORY = 'INCOME_AND_EXPENSE_CATEGORY',
    INSURANCES = 'INSURANCES',
    INSURANCES_DETAILS = 'INSURANCES_DETAILS',
    INSURANCES_ADDPRODUCT = 'INSURANCES_ADDPRODUCT',
    INSURANCES_PRODUCTPAGE = 'INSURANCES_PRODUCTPAGE',
    INSURANCES_MAINTENANCE = 'INSURANCES_MAINTENANCE',
    INVESTMENT_MANAGE = 'INVESTMENT_MANAGE',
    INVESTMENT_ORDER = 'INVESTMENT_ORDER',
    INVESTMENT_ORDER_HISTORY = 'INVESTMENT_ORDER_HISTORY',
    INVESTMENT_ORDER_OVERVIEW = 'INVESTMENT_ORDER_OVERVIEW',
    INVESTMENT_OVERVIEW = 'INVESTMENT_OVERVIEW',
    INVESTMENT_FINANCIAL_RETURN = 'INVESTMENT_FINANCIAL_RETURN',
    INVESTMENT_ORDERS = 'INVESTMENT_ORDERS',
    INVESTMENT_SUSTAINABLE_RETURN = 'INVESTMENT_SUSTAINABLE_RETURN',
    INVESTMENT_PLANNER = 'INVESTMENT_PLANNER',
    INVESTMENT_PLANNER_OVERVIEW = 'INVESTMENT_PLANNER_OVERVIEW',
    INVESTMENT_ORDER_ALLOCATION = 'INVESTMENT_ORDER_ALLOCATION',
    INVESTMENT_SIGN = 'INVESTMENT_SIGN',
    INVESTMENT_COMPLETE = 'INVESTMENT_COMPLETE',
    INVESTMENT_CANCEL_ACCOUNT = 'INVESTMENT_CANCEL_ACCOUNT',
    INVESTMENT_PORTFOLIO = 'INVESTMENT_PORTFOLIO',
    INVESTMENT_CASH = 'INVESTMENT_CASH',
    INVESTMENT_VIEW = 'INVESTMENT_VIEW',
    LOAN_APPLY = 'LOAN_APPLY',
    LOAN_APPLY_MANAGE = 'LOAN_APPLY_MANAGE',
    MAKE_TRANSFER = 'MAKE_TRANSFER',
    MESSAGE_OVERVIEW = 'MESSAGE_OVERVIEW',
    MESSAGE_VIEW = 'MESSAGE_VIEW',
    MORTGAGE_ADDITIONAL_PAYMENT = 'MORTGAGE_ADDITIONAL_PAYMENT',
    MORTGAGE_BUILD_FUND_DECLARE = 'MORTGAGE_BUILD_FUND_DECLARE',
    MORTGAGE_BUILD_FUND_NEW_ADDRESS = 'MORTGAGE_BUILD_FUND_NEW_ADDRESS',
    MORTGAGE_BUILD_FUND_TERMINATE = 'MORTGAGE_BUILD_FUND_TERMINATE',
    MORTGAGE_CHANGE_COLLECTION_ACCOUNT = 'MORTGAGE_CHANGE_COLLECTION_ACCOUNT',
    MORTGAGE_CONVERT = 'MORTGAGE_CONVERT',
    MORTGAGE_DOCUMENTUPLOAD = 'MORTGAGE_DOCUMENTUPLOAD',
    MORTGAGE_HOUSE_VALUE = 'MORTGAGE_HOUSE_VALUE',
    MORTGAGE_INCREASE = 'MORTGAGE_INCREASE',
    MORTGAGE_INCREASE_KNOWLEDGE_TEST = 'MORTGAGE_INCREASE_KNOWLEDGE_TEST',
    MORTGAGE_INCREASE_REQUEST = 'MORTGAGE_INCREASE_REQUEST',
    MORTGAGE_INTEREST_ADJUST = 'MORTGAGE_INTEREST_ADJUST',
    MORTGAGE_INTEREST_EXTEND = 'MORTGAGE_INTEREST_EXTEND',
    MORTGAGE_INTEREST_ONLY_CHECK = 'MORTGAGE_INTEREST_ONLY_CHECK',
    MORTGAGE_NEXT_PAYMENT = 'MORTGAGE_NEXT_PAYMENT',
    MORTGAGE_OVERVIEW = 'MORTGAGE_OVERVIEW',
    MORTGAGE_OVERVIEW_DETAILS = 'MORTGAGE_OVERVIEW_DETAILS',
    MORTGAGE_OVERVIEW_ENERGYLABEL = 'MORTGAGE_OVERVIEW_ENERGYLABEL',
    MORTGAGE_PREVIOUS_PAYMENTS = 'MORTGAGE_PREVIOUS_PAYMENTS',
    MORTGAGE_REDEEM = 'MORTGAGE_REDEEM',
    OVERVIEW = 'OVERVIEW',
    OVERVIEW_ACCOUNTS = 'OVERVIEW_ACCOUNTS',
    OVERVIEW_EDIT = 'OVERVIEW_EDIT',
    PAGE_NOT_FOUND = 'PAGE_NOT_FOUND',
    PAYMENT_BATCHES = 'PAYMENT_BATCHES',
    PAYMENT_BATCHES_AFGEROND_BESTAND = 'PAYMENT_BATCHES_AFGEROND_BESTAND',
    PAYMENT_BATCHES_BATCH_DETAILS = 'PAYMENT_BATCHES_BATCH_DETAILS',
    PAYMENT_BATCHES_BATCH_BESTAND_DETAILS = 'PAYMENT_BATCHES_BATCH_BESTAND_DETAILS',
    PAYMENT_BATCHES_SIGN = 'PAYMENT_BATCHES_SIGN',
    PAYMENT_BATCHES_RESULT = 'PAYMENT_BATCHES_RESULT',
    PAYMENT_BATCHES_UPLOAD = 'PAYMENT_BATCHES_UPLOAD',
    PAYMENT_REQUEST = 'PAYMENT_REQUEST',
    PAYMENT_REQUEST_FORM = 'PAYMENT_REQUEST_FORM',
    PAYMENTS_OVERVIEW = 'PAYMENTS_OVERVIEW',
    PAYMENTS_SIGN = 'PAYMENTS_SIGN',
    PAYMENTS_SUMMARY = 'PAYMENTS_SUMMARY',
    PAYMENTS_PIGGYBANK_SUMMARY = 'PAYMENTS_PIGGYBANK_SUMMARY',
    PENDING_PAYMENTS = 'PENDING_PAYMENTS',
    PENSION_EXPANSION_REQUEST_INVESTMENT = 'PENSION_EXPANSION_REQUEST_INVESTMENT',
    PENSION_EXPANSION_REQUEST_DEPOSIT = 'PENSION_EXPANSION_REQUEST_DEPOSIT',
    PERSONAL_LOAN_OVERVIEW = 'PERSONAL_LOAN_OVERVIEW',
    PERSONAL_LOAN_VIEW = 'PERSONAL_LOAN_VIEW',
    PIGGY_BANKS = 'PIGGY_BANKS',
    PLANNED_PAYMENT = 'PLANNED_PAYMENT',
    PLANNED_PAYMENT_VIEW = 'PLANNED_PAYMENT_VIEW',
    SECURITY_AWARENESS_TRAINING = 'SECURITY_AWARENESS_TRAINING',
    SELF_SERVICE = 'SELF_SERVICE',
    SELF_SERVICE_ACCOUNTS = 'SELF_SERVICE_ACCOUNTS',
    SELF_SERVICE_ADD_PRODUCT = 'SELF_SERVICE_ADD_PRODUCT',
    SELF_SERVICE_ALERTS = 'SELF_SERVICE_ALERTS',
    SELF_SERVICE_ALERTS_INCASSO = 'SELF_SERVICE_ALERTS_INCASSO',
    SELF_SERVICE_ALERTS_INTRODUCTION = 'SELF_SERVICE_ALERTS_INTRODUCTION',
    SELF_SERVICE_ALERTS_OLD = 'SELF_SERVICE_ALERTS_OLD',
    SELF_SERVICE_ALERTS_PENDING_PAYMENT = 'SELF_SERVICE_ALERTS_PENDING_PAYMENT',
    SELF_SERVICE_ALERTS_PENDING_PAYMENT_EDIT = 'SELF_SERVICE_ALERTS_PENDING_PAYMENT_EDIT',
    SELF_SERVICE_ALERTS_SALDO = 'SELF_SERVICE_ALERTS_SALDO',
    SELF_SERVICE_ALERTS_SALDO_EDIT = 'SELF_SERVICE_ALERTS_SALDO_EDIT',
    SELF_SERVICE_ALERTS_SECURITY = 'SELF_SERVICE_ALERTS_SECURITY',
    SELF_SERVICE_ALERTS_TRANSACTION = 'SELF_SERVICE_ALERTS_TRANSACTION',
    SELF_SERVICE_ALERTS_TRANSACTION_EDIT = 'SELF_SERVICE_ALERTS_TRANSACTION_EDIT',
    SELF_SERVICE_AUTH_TOKENS = 'SELF_SERVICE_AUTH_TOKENS',
    SELF_SERVICE_AUTH_TOKENS_REMOVE_DIGIPAS = 'SELF_SERVICE_AUTH_TOKENS_REMOVE_DIGIPAS',
    SELF_SERVICE_AUTOMATIONS = 'SELF_SERVICE_AUTOMATIONS',
    SELF_SERVICE_CANCELLED_ACCOUNTS = 'SELF_SERVICE_CANCELLED_ACCOUNTS',
    SELF_SERVICE_CHANGE_USERNAME_PASSWORD = 'SELF_SERVICE_CHANGE_USERNAME_PASSWORD',
    SELF_SERVICE_CONTACT_DETAILS = 'SELF_SERVICE_CONTACT_DETAILS',
    SELF_SERVICE_CURRENT_AFFAIRS = 'SELF_SERVICE_CURRENT_AFFAIRS',
    SELF_SERVICE_ECOMMERCE = 'SELF_SERVICE_ECOMMERCE',
    SELF_SERVICE_ECOMMERCE_PAYMENT = 'SELF_SERVICE_ECOMMERCE_PAYMENT',
    SELF_SERVICE_ECOMMERCE_SUMMARY = 'SELF_SERVICE_ECOMMERCE_SUMMARY',
    SELF_SERVICE_HERIDENTIFICATIE = 'SELF_SERVICE_HERIDENTIFICATIE',
    SELF_SERVICE_UNBLOCK_DIGIPAS = 'SELF_SERVICE_UNBLOCK_DIGIPAS',
    SELF_SERVICE_IDEAL = 'SELF_SERVICE_IDEAL',
    SELF_SERVICE_IDEAL_DETAILS = 'SELF_SERVICE_IDEAL_DETAILS',
    SELF_SERVICE_IDEAL_ERROR = 'SELF_SERVICE_IDEAL_ERROR',
    SELF_SERVICE_IDEAL_MAKE_PROFILE = 'SELF_SERVICE_IDEAL_MAKE_PROFILE',
    SELF_SERVICE_IDIN = 'SELF_SERVICE_IDIN',
    SELF_SERVICE_MESSAGEPREFERENCES = 'SELF_SERVICE_MESSAGEPREFERENCES',
    SELF_SERVICE_MESSAGE_PREFERENCES_NBA = 'SELF_SERVICE_MESSAGE_PREFERENCES_NBA',
    SELF_SERVICE_MORTGAGES = 'SELF_SERVICE_MORTGAGES',
    SELF_SERVICE_ONLINE_BANKING_CHILD = 'SELF_SERVICE_ONLINE_BANKING_CHILD',
    SELF_SERVICE_PAYMENT_CARDS = 'SELF_SERVICE_PAYMENT_CARDS',
    SELF_SERVICE_PREFERREDACCOUNT = 'SELF_SERVICE_PREFERREDACCOUNT',
    SELF_SERVICE_PRIVACY = 'SELF_SERVICE_PRIVACY',
    SELF_SERVICE_MANAGE_ACCESS = 'SELF_SERVICE_MANAGE_ACCESS',
    SELF_SERVICE_PRODUCT_AANVRAGEN = 'SELF_SERVICE_PRODUCT_AANVRAGEN',
    SELF_SERVICE_PRODUCT_CATALOG = 'SELF_SERVICE_PRODUCT_CATALOG',
    SELF_SERVICE_REFUSED_PAYMENTS = 'SELF_SERVICE_REFUSED_PAYMENTS',
    SELF_SERVICE_REFUSED_PAYMENTS_VIEW = 'SELF_SERVICE_REFUSED_PAYMENTS_VIEW',
    SELF_SERVICE_SAFETY_ACCESS = 'SELF_SERVICE_SAFETY_ACCESS',
    SELF_SERVICE_SHARING_ACCESS = 'SELF_SERVICE_SHARING_ACCESS',
    SELF_SERVICE_THIRD_PARTY_ACCESS = 'SELF_SERVICE_THIRD_PARTY_ACCESS',
    SELF_SERVICE_TOEGANGSNAAM_WACHTWOORD_AANVRAGEN = 'SELF_SERVICE_TOEGANGSNAAM_WACHTWOORD_AANVRAGEN',
    SELF_SERVICE_TOKEN_LIMITS = 'SELF_SERVICE_TOKEN_LIMITS',
    SELF_SERVICE_TOKENS_AUTHENTICATION_HISTORY = 'SELF_SERVICE_TOKENS_AUTHENTICATION_HISTORY',
    SELF_SERVICE_TRANSACTIONS_DOWNLOAD = 'SELF_SERVICE_TRANSACTIONS_DOWNLOAD',
    SELF_SERVICE_ACCOUNTBALANCES_DOWNLOAD = 'SELF_SERVICE_ACCOUNTBALANCES_DOWNLOAD',
    SORRY = 'SORRY',
    TELEPHONY_CONSENT = 'TELEPHONY_CONSENT',
    WIJZIGEN_AFSCHRIFTFREQUENTIE = 'WIJZIGEN_AFSCHRIFTFREQUENTIE',
    ZAKELIJK_EXTRA_AFLOSSEN = 'ZAKELIJK_EXTRA_AFLOSSEN',
    ZAKELIJK_DIGIPAS_VERVANGEN = 'ZAKELIJK_DIGIPAS_VERVANGEN',
    SELF_SERVICE_DYNAMIC_PROCESS = 'SELF_SERVICE_DYNAMIC_PROCESS'
}

export interface MijnRoute {
    path: string;
    regex: RegExp;
    navigationEvent: string;
    internalPath?: string;
    webcomponent?: string;
    params?: Params;
}

export interface MijnNavigatieHistory {
    enabled: boolean;
    routes: MijnNavigatieRoute[];
}

export interface MijnNavigatieRoute {
    breadcrumb: string;
    url: string;
}
